import { render, staticRenderFns } from "./UserTabSecurity.vue?vue&type=template&id=5b3153e4&"
import script from "./UserTabSecurity.vue?vue&type=script&lang=js&"
export * from "./UserTabSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports